import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Mentorspanelists({ handleShow }) {
  return (
    <section className="mentors_panelists p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={4} xxl={4} className="">
            <h2 style={{ color: "#000" }}>Mentors and Panelists</h2>
            <p>
              A mentor can help you set goals, your skills, and navigate your
              Startups
            </p>
            <button
              onClick={handleShow}
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get Started Now!
            </button>
          </Col>
          <Col xs={12} md={12} lg={12} xl={8} xxl={8} className="mt-xl-0 mt-4">
            <div className="ment-main">
              <div className="ment-item">
                <StaticImage
                  src="../../../images/landing/rv-community/james_utechin.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={328}
                  height={817}
                />
                <div className="ment-content">
                  <h4>James Utechin</h4>
                </div>
              </div>
              <div className="ment-item">
                <StaticImage
                  src="../../../images/landing/rv-community/ann_gray.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={328}
                  height={817}
                />
                <div className="ment-content">
                  <h4>Ann Gray</h4>
                </div>
              </div>
              <div className="ment-item">
                <StaticImage
                  src="../../../images/landing/rv-community/emily_waltham.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={328}
                  height={817}
                />
                <div className="ment-content">
                  <h4>Emily Waltham</h4>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Mentorspanelists;
